import type { AuthTenant, AuthUser } from '../lib/types';

interface VariantBannerProps {
  tenant: AuthTenant | null;
  user: AuthUser | null;
  capabilities: string[];
}

const TIER_LABEL_MAP: Record<string, string> = {
  solo: 'Solo',
  team: 'Team',
  professional: 'Team-Professional',
  regulated: 'Regulated',
};

/**
 * VariantBanner canonical — Sprint Visual Brief 2A r7b (Agent A SHELL).
 *
 * Banner amarelo (--brand-subtle) sob a topbar mostrando:
 *   "Variant ativo:" [pill: Team-Professional]
 *   tenant · operator · (preview customer atual virá da Conversa em curso)
 *   N capabilities ativas
 *
 * Em runtime real (não protótipo standalone.html canonical), o cliente
 * atual ("Roberto Almeida") só é conhecido quando há conversa selecionada.
 * Mantém placeholder sem cliente quando rota = listagem.
 */
export function VariantBanner({ tenant, user, capabilities }: VariantBannerProps): JSX.Element {
  const tier = TIER_LABEL_MAP[tenant?.packageType ?? ''] ?? tenant?.packageType ?? '—';
  const tenantName = tenant?.name ?? '—';
  const userName = user?.name ?? '—';
  const capCount = capabilities.length;

  return (
    <div
      className="variant-banner"
      role="status"
      aria-label={`Variant ativo: ${tier}, ${capCount} capabilities ativas`}
    >
      <span style={{ fontWeight: 600 }}>Variant ativo:</span>
      <span className="variant-banner__pill">{tier}</span>
      <span className="variant-banner__spacer">
        {tenantName} · {userName}
      </span>
      <span className="variant-banner__caps">{capCount} capabilities ativas</span>
    </div>
  );
}
